module.exports = __webpack_public_path__ + "img/swords-laser.827b3c1d.svg";